import { Column, Grid, Row, Link } from "carbon-components-react";

import { Item } from "./Item";

export const BabyStatusSummaryStatusViewer = ({
  loading = false,
  data = {},
  onChangeLimit,
}) => {
  if (loading) {
    return (
      <>
        <Grid>
          <Row>
            <Column>
              <Item loading={loading} />
            </Column>
          </Row>
        </Grid>
        <Grid>
          <Row>
            <Column>
              <Item loading={loading} />
            </Column>
          </Row>
        </Grid>
      </>
    );
  }

  const fieldKeys = Object.keys(data);
  const fieldWithValue = fieldKeys.map((k) => {
    const { name, fields } = data[k];
    return {
      key: k,
      name: name,
      fields: fields,
    };
  });

  return (
    <>
      {fieldWithValue.map((value) => {
        return (
          <>
            <Item labelText={value.name} loading={loading} />
            <Grid>
              <Row>
                {value.fields.map((vf) => {
                  /* console.debug(`${value.key} ${value.name} ${vf.key} ${vf.lq}`); */
                  const display =
                    vf.query_params === undefined ? (
                      `${vf.value}`
                    ) : (
                      <Link
                        onClick={() => {
                          onChangeLimit({
                            key: value.key,
                            title: value.name,
                            value_name: vf.name,
                            query: vf.query_params,
                          });
                        }}
                        disabled={vf.query_params === ""}
                      >
                        {vf.value}
                      </Link>
                    );
                  return (
                    <Column>
                      <Item labelText={vf.name} loading={loading}>
                        {display}
                      </Item>
                    </Column>
                  );
                })}
              </Row>
            </Grid>
          </>
        );
      })}
    </>
  );
};
